module.exports = __webpack_public_path__ + "h5/img/kefu_icon_kf.da7755e2.png";